module.exports = __webpack_public_path__ + "img/dpc_gomb.edf0c3e9.png";